import './styles.scss';

export const Card = ({
  children,
  className: cssClass,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  const className = cssClass ? `card-container ${cssClass}` : 'card-container';
  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};
